import { render, staticRenderFns } from "./AttendanceTables.vue?vue&type=template&id=6bcbf48a&"
import script from "./AttendanceTables.vue?vue&type=script&lang=js&"
export * from "./AttendanceTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports